export const EVENT_BLUR = 'blur';
export const EVENT_CHANGE = 'change';
export const EVENT_CLICK = 'click';
export const EVENT_FOCUS = 'focus';
export const EVENT_KEYDOWN = 'keydown';
export const EVENT_MOUSEENTER = 'mouseenter';
export const EVENT_MOUSELEAVE = 'mouseleave';
export const EVENT_RESIZE = 'resize';
export const EVENT_SCROLL = 'scroll';
export const EVENT_SUBMIT = 'submit';
